import React, { createContext, useState, useRef, useEffect } from "react";
import { useRouter } from "next/router";

export const AudioPlayerContext = createContext();

export const AudioPlayerProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioSource, setAudioSource] = useState(null);
  const audioRef = useRef(null);
  const router = useRouter();

  useEffect(() => {
    if (typeof window !== "undefined" && !audioRef.current) {
      audioRef.current = new Audio();
    }
  }, []);

  const playAudio = (source) => {
    if (!audioRef.current) return;
    if (audioSource !== source) {
      setAudioSource(source);
      audioRef.current.src = source;
    }
    audioRef.current.play();
    setIsPlaying(true);
  };

  const pauseAudio = () => {
    if (!audioRef.current) return;
    audioRef.current.pause();
    setIsPlaying(false);
  };

  const toggleAudio = (source) => {
    if (!audioRef.current) return;
    if (audioSource !== source) {
      playAudio(source);
    } else {
      if (isPlaying) {
        pauseAudio();
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const onAudioEnded = (nextChapter) => {
    if (nextChapter) {
      router.push(nextChapter);
    }
  };

  return (
    <AudioPlayerContext.Provider value={{ isPlaying, audioSource, playAudio, pauseAudio, toggleAudio, audioRef, onAudioEnded }}>
      {children}
    </AudioPlayerContext.Provider>
  );
};
